import React, { Component } from 'react';
import {
	SketchPicker,
	PhotoshopPicker,
	ChromePicker,
	BlockPicker,
	GithubPicker,
	HuePicker,
	AlphaPicker,
	TwitterPicker,
	CirclePicker,
	SliderPicker,
	CompactPicker,
	MaterialPicker,
	SwatchesPicker
} from 'react-color';
import './style/index.less';
/**
 * 时钟组件
 */
class ColorPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			displayColorPicker: false,
			style: {
				left: 100,
				top: 200
			}
		};
	}

	handleClick = () => {
		this.setState({
			displayColorPicker: !this.state.displayColorPicker,
		}, () => {
			let element = this.inputDom;
			let elementcolor = this.selectBoxDom;
			let X = element.getBoundingClientRect().left;
			let Y = element.getBoundingClientRect().top;
			let colorInputWidth = element.clientWidth;
			let colorInputHeight = element.clientHeight;
			let colorBoxWidth = elementcolor.clientWidth;
			let colorBoxHeight = elementcolor.clientHeight;

			let left = X - colorBoxWidth - 5;
			let top = Y - colorBoxHeight - 5;
			//如果颜色选择框位置超出顶部，则显示到下面
			if (left < 0) {
				left = X + colorInputWidth + 5;
			}
			if (top < 0) {
				top = Y + colorInputHeight + 5;
			}

			this.setState({
				style :{
					left: left,
					top: top,
				}
			});
		});
  	};

	handleChange = (color) => {
		let { onChange } = this.props;
		onChange && onChange(color);
	};

	handleClose = (color) => {
		let { onBlur } = this.props;
		onBlur && onBlur(color);
		this.setState({ displayColorPicker: false });
	};

	render() {
		let { left, top } = this.state.style;
		const boxcover = {
			position: 'fixed', 
			left, 
			top, 
			zIndex: 9999,
		};
		const cover = {
			position: 'fixed',
			top: '0px',
			right: '0px',
			bottom: '0px',
			left: '0px'
		};
		let { type, color, width, style, disableAlpha : disableAlpha = true } = this.props;
		let colorPickerProps = {
			color,
			onChange: (color) => {
				this.handleChange(color);
			}
    	};
		let colorPicker = null;
		if (type === 'SketchPicker') {
			colorPicker = <SketchPicker {...colorPickerProps} />;
		} else if (type === 'PhotoshopPicker') {
			colorPicker = <PhotoshopPicker {...colorPickerProps} />;
		} else if (type === 'ChromePicker') {
			//注意，默认这个选择器取消了Alpha透明度的选择
			//如果打开Alpha透明度选择，会导致生成播放列表的color或者bgcolor的值为transparent，从而导致机器播放解析崩溃
			colorPicker = <ChromePicker {...colorPickerProps} disableAlpha={disableAlpha} />;
		} else if (type === 'BlockPicker') {
			colorPicker = <BlockPicker {...colorPickerProps} />;
		} else if (type === 'GithubPicker') {
			colorPicker = <GithubPicker {...colorPickerProps} />;
		} else if (type === 'HuePicker') {
			colorPicker = <HuePicker {...colorPickerProps} />;
		} else if (type === 'AlphaPicker') {
			colorPicker = <AlphaPicker {...colorPickerProps} />;
		} else if (type === 'TwitterPicker') {
			colorPicker = <TwitterPicker {...colorPickerProps} />;
		} else if (type === 'CirclePicker') {
			colorPicker = <CirclePicker {...colorPickerProps} />;
		} else if (type === 'SliderPicker') {
			colorPicker = <SliderPicker {...colorPickerProps} />;
		} else if (type === 'CompactPicker') {
			colorPicker = <CompactPicker {...colorPickerProps} />;
		} else if (type === 'MaterialPicker') {
			colorPicker = <MaterialPicker {...colorPickerProps} />;
		} else if (type === 'SwatchesPicker') {
			colorPicker = <SwatchesPicker {...colorPickerProps} />;
		}
		return (
			<React.Fragment>
				{this.state.displayColorPicker ? (
					<div ref={dom => {
						return (this.selectBoxDom = dom);
					}} style={boxcover}>
						<div 
							style={cover}
							onClick={() => {
								this.handleClose(color);
							}}
						/>
						{colorPicker}
					</div>
					) : null}
				<input
					type="text"
					ref={dom => {
						return (this.inputDom = dom);
					}}
					className="ant-input ant-input-sm"
					style={{ width, cursor: 'pointer', backgroundColor: color, ...style }}
					onClick={() => {
						this.handleClick();
					}}
					readOnly />
			</React.Fragment>
		);
	}
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/Color/ColorPicker.js